<div class="rm-header space-between">
  <span *ngIf="noteType == NoteTypes.DEAL">Deal Notes</span>
  <span *ngIf="noteType == NoteTypes.MANDATE">[ADMIN] Mandate Notes</span>
  <span *ngIf="noteType == NoteTypes.BUSINESSUNIT">[ADMIN] Business Unit Notes</span>
  <mat-icon mat-dialog-close title="close">close</mat-icon>
</div>
<mat-dialog-content>
  <div style="display: flex; width: 100%; justify-content: space-between; gap: 15px; align-items: center;">
    <mat-select name="collection" [(ngModel)]="selectedCollection" (selectionChange)="changeNoteCollection($event)">
      <mat-option *ngFor="let c of noteCollections" [value]="c">{{ c.name }}</mat-option>
    </mat-select>
    <mat-icon style="cursor: pointer" (click)="getNotes(selectedCollection)" title="Refresh Notes">refresh
    </mat-icon>
  </div>
  <div #scrollMe class="notes-messages-container mt-4 mb-2">
    <div class="full-width" *ngFor="let note of notesList; index as i;">
      <div class="message" [ngClass]="note.isNoteOwner === true ? 'isOwner' : 'notOwner'">
        <div class="message-body">
          <span style="overflow-wrap: anywhere;">{{note.note}}</span>
          <span>
            <mat-icon class="pointer" *ngIf="note.isNoteOwner" [matMenuTriggerFor]="menu">more_vert</mat-icon>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="editNote(note)" [disabled]="!canEditNote"
                title="Edit Note"
                >Edit Note</button>
              <button mat-menu-item (click)="deleteNote(note)" [disabled]="!canDeleteNote"
                [disabled]="!note.isNoteOwner"
                title="Delete Note"
                >Delete Note</button>
            </mat-menu>
          </span>
        </div>
        <div class="message-meta">
          <span>{{note.createdBy.firstName}} {{note.createdBy.lastName}}</span>
          <span>{{note.created | date : 'medium'}}</span>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="full-width">
  <form class="full-width" (ngSubmit)="sendNewMessage()">
    <mat-form-field class="form-field" appearance="outline">
      <mat-label>{{ isEditing ? 'Edit Note' : 'Add New Note' }}</mat-label>
      <input name="note" matInput autocomplete="off" placeholder="Type here..." [(ngModel)]="noteBody" [disabled]="!canAddNote" />
      <button mat-icon-button matSuffix type="submit" [disabled]="!noteBody">
        <mat-icon>send</mat-icon>
      </button>
      <button mat-icon-button type="button" matSuffix *ngIf="isEditing" (click)="clearEditModeAndForm()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  </form>
</mat-dialog-actions>

